import api from "@/services/api"

export default {
    methods:{
        async getAxurs(){
            try {
                this.filter = Object.assign(this.filter, {
                    idCompany: this.companyId,
                });
                delete this.filter['startDate']
                delete this.filter['endDate']

                const { data } = await api.getAxurLoki(this.filter)
                this.acordeon.forEach((el) => {
                    if (el.origin === "axur") {
                        el.table["items"] = data
                        el.table["items"].content = data.content?.map((mp) => {
                            return {
                                ...mp,
                                status: this.getStatusName(mp.status),
                                route: "axur",
                                buttons: this.getButtons(mp.axurFindingsSummarizedDTO)
                            };
                        }) || []
                        el.table['rows'] = data.totalElements;
                    }
                });
            } catch (error) {
                this.errorCatch(error)
            }
        },

        getButtons(axurFidings){
            const array = []
            if(axurFidings.amountAxurOneFindings > 0) array.push('AXUR_ONE')
            if(axurFidings.amountDarWebFindings > 0) array.push('DARK_WEB')
            return array
        }
    }
}